import { getPortalTokens } from '../../styles/portalTheme';

/** Shared partner dashboard visual tokens (derived from portal theme). */

const tokens = getPortalTokens('light');

export const PARTNER_BRAND = tokens.accent;
export const PARTNER_BRAND_HOVER = tokens.accentHover;
export const PARTNER_BRAND_SOFT = tokens.accentSoft;
export const PARTNER_BRAND_SOFT_STRONG = 'rgba(232, 114, 114, 0.16)';

export const getPartnerCardSx = (portal = tokens) => ({
  borderRadius: '12px',
  bgcolor: portal.surface,
  boxShadow: portal.cardShadow,
  border: `1px solid ${portal.border}`,
});

export const PARTNER_CARD_SX = getPartnerCardSx(tokens);

export const getPartnerIconBadgeSx = (portal = tokens) => ({
  width: 40,
  height: 40,
  borderRadius: '10px',
  bgcolor: portal.accentSoft,
  color: portal.accent,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

export const PARTNER_ICON_BADGE_SX = getPartnerIconBadgeSx(tokens);

export const PARTNER_PAGE_BG = tokens.pageBg;

/** Logo / avatar used on dashboard hero and settings company info. */
export const PARTNER_LOGO_SIZE = 120;

export const PARTNER_LOGO_SHAPES = {
  /** Dashboard hero — rounded square */
  square: '12px',
  /** Company info — circular */
  circle: '50%',
};

const PARTNER_LOGO_BASE_SX = {
  width: PARTNER_LOGO_SIZE,
  height: PARTNER_LOGO_SIZE,
  bgcolor: '#F5D5C8',
  color: '#C45C2a',
  fontWeight: 600,
  fontSize: '2.25rem',
  border: '3px solid',
  borderColor: 'background.paper',
  boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  flexShrink: 0,
};

/** @param {'square' | 'circle'} shape */
export const getPartnerLogoAvatarSx = (shape = 'circle') => ({
  ...PARTNER_LOGO_BASE_SX,
  borderRadius: PARTNER_LOGO_SHAPES[shape] ?? PARTNER_LOGO_SHAPES.circle,
});

/** @deprecated Use getPartnerLogoAvatarSx('circle') or PartnerLogoAvatar */
export const PARTNER_LOGO_AVATAR_SX = getPartnerLogoAvatarSx('circle');

export const PARTNER_DEFAULT_BANNER_URL =
  'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1400&h=280&fit=crop';

export {
  brandSwitchStyles as PARTNER_SWITCH_SX,
  getBrandSwitchStyles,
} from '../../styles/brandSwitchStyles';
